
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';


function SaleEditDetails() {

    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];

    const monthstartdate = new Date();
    monthstartdate.setDate(1); // Set the day to 1 to get the start of the month
    const formattedStartDate = monthstartdate.toISOString().split('T')[0];


    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        setFromDate(formattedStartDate);
        setToDate(formattedDate);
        fetchTableData();

    }, [isAuthenticated, companyId, token, logout]);


    const hasReadReportPermission = permissions.includes('Read Reports');


    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            try {
                const response = await fetchData('ReportApi', `/BillEditDetails/${companyId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }

            } catch (error) {
                console.error('Error fetching Edit Bill Details:', error);
            }
        }
    };


    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const totalAmt = filteredData.reduce((sum, rowData) => sum + rowData.totalamount, 0);
    const ptotalAmt = filteredData.reduce((sum, rowData) => sum + rowData.previoustotalamount, 0);


    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    //print
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Edit Bill Details</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Edit Bill Details</h3>');
        printWindow.document.write(`<h4 style="font-family: Times New Roman; font-size: 22px;">From : ${formatDate(fromDate)} To : ${formatDate(toDate)}</h4>`);
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Table Name</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Previous Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Modified By</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Modified Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Type</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        filteredData.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${index + 1}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.invoicenumber}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${formatDate(rowData.invoicedate)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.tablename}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.previoustotalamount}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.totalamount}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.modifiedby}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.modifieddate}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.changetype}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('<tr>');
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);
        printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">Total</td>');
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${ptotalAmt}</td>`);
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${totalAmt}</td>`);
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);
        printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;"></td>`);

        printWindow.document.write('</tr>');


        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };

    //excel

    const handleExportExcel = () => {
        const excelData = [];


        // Add header row

        const headerCaption = [
            `Edited Bill Details From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`
        ];
        excelData.push(headerCaption);

        const headerRow = [
            'Sl.No',
            'Bill No',
            'Bill Date',
            'Table Name',
            'Previous Amount',
            'Amount',
            'Modified By',
            'Modified Date',
            'Type'
        ];
        excelData.push(headerRow);

        // Add data rows

        filteredData.forEach((rowData, index) => {
            const dataRow = [
                index + 1,
                rowData.invoicenumber,
                formatDate(rowData.invoicedate),
                rowData.tablename,
                rowData.previoustotalamount,
                rowData.totalamount,
                rowData.modifiedby,
                formatDate(rowData.modifieddate),
                rowData.changetype,
            ];
            excelData.push(dataRow);
        });

        const dataRow1 = [
            '',
            'Total',
            ' ',
            ' ',
            ptotalAmt,
            totalAmt,
            '',
            ' ',
            '',
        ];
        excelData.push(dataRow1);

        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Edit Bill Details');
        XLSX.writeFile(wb, 'EditBillDetails.xlsx');

    };



    const [isFocused, setIsFocused] = useState(false);


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            {/* <div className='w-full mb-2 flex'>
                <h3 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', fontSize: '30px' }}>Edited Bill Details</h3>
            </div>
            <div className='w-full mb-2 flex'>

                <div className="mr-2" style={{ maxWidth: '150px' }}>
                    <label className="block tracking-wide text-white text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)}

                    />
                </div>

                <div className="mr-2" style={{ maxWidth: '150px' }}>
                    <label className="block tracking-wide text-white text-xs font-bold mb-2" htmlFor="toDate" style={{ fontSize: '16px' }}>
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={(e) => setToDate(e.target.value)}

                    />
                </div>
            </div>

            <div className='w-full mb-2 flex'>
                <button
                    onClick={fetchTableData}
                    style={{
                        marginLeft: '10px',
                        cursor: 'pointer',
                        backgroundColor: '#00D100',
                        color: 'white',
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '16px',
                        height: '45px',
                    }}
                >
                    Refresh
                </button>
                <button
                    onClick={handleExportExcel}
                    style={{
                        marginLeft: '10px',
                        cursor: 'pointer',
                        backgroundColor: '#009688',
                        color: 'white',
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '16px',
                        height: '45px',
                    }}
                >
                    Excel
                </button>

                <button
                    onClick={handlePrint}
                    style={{
                        marginLeft: '10px',
                        cursor: 'pointer',
                        backgroundColor: '#ff5733',
                        color: 'white',
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '16px',
                        height: '45px',
                    }}
                >
                    Print
                </button>
                <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>

                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px' }}
                        />
                    )}
                </div>

            </div> */}

            <div className='w-full mb-2 flex'>
                <h5 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>EDITED BILL DETAILS</h5>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '300px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                marginTop: '22px'
                            }}
                        />
                    </div>
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)}

                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={(e) => setToDate(e.target.value)}

                    />
                </div>
                <Button
                    style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '20px' }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >

                    <span style={{ color: 'darkgreen', fontWeight: 'bolder', marginTop: '-5px' }}>REFRESH</span>
                </Button>

                <Button
                    style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '20px' }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >

                    <span style={{ color: 'darkblue', fontWeight: 'bolder', marginTop: '-5px' }}>EXCEL</span>
                </Button>

                <Button
                    style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '20px' }}
                    onClick={handlePrint}
                    className="linkcolor"
                >

                    <span style={{ color: 'orange', fontWeight: 'bolder', marginTop: '-5px' }}>PRINT</span>
                </Button>


            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Bill No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Table</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Previous Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Modified By</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Modified Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Type</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.map((data, index) => (
                                <TableRow key={data.id}>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>
                                        <Link to={`/SaleDetail/${data.id}`}>
                                            {data.invoicenumber}
                                        </Link>
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{formatDate(data.invoicedate)}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{data.tablename}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{data.previoustotalamount}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{data.totalamount}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{data.modifiedby}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{formatDate(data.modifieddate)}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px' }}>{data.changetype}</TableCell>
                                </TableRow>
                            ))}
                            {/* Add total row at the end */}
                            <TableRow>
                                <TableCell colSpan={4} sx={{ fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>Total</TableCell>
                                <TableCell sx={{ fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>{ptotalAmt}</TableCell>
                                <TableCell sx={{ fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}>{totalAmt}</TableCell>
                                <TableCell sx={{ fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}></TableCell>
                                <TableCell sx={{ fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}></TableCell>
                                <TableCell sx={{ fontSize: '16px', fontWeight: 'bolder', color: 'black', padding: '8px' }}></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>


        </div>


    );
}

export default SaleEditDetails;
